import React from 'react';
import '../styles/supportAndRules.css';

const SupportAndRules = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <section className="support-rules-section">
      <div className="support">
        <h2 className="section-title"><span className="highlight">Get Support </span>– Contact <span className="highlight">Mahadev Book</span> Whatsapp Number</h2>
        <p>
          Technical issues within your Mahadev Book account require help from the 24/7 customer support team.
          The 24-hour customer support team at Mahadev Book stands ready to help all of our users. Reach out to us through:
        </p>
        <ul className="support-list">
          <li>✅ <strong>WhatsApp</strong> – Get instant solutions from our team.</li>
          <li>✅ <strong>Live Chat</strong> – Quick support for app-related queries.</li>
          <li>✅ <strong>Email Support</strong> – Send us your concerns for a detailed response.</li>
          <li>✅ <strong>Helpline</strong> – Call our toll-free number during working hours.</li>
        </ul>
        <p>
          We exist to provide a convenient and trouble-free experience for all our users. Contact us anytime for assistance!
        </p>
        <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 8888568888
        </a>
      </div>

      <div className="rules">
        <h2 className="section-title"><span className="highlight">Mahadev Book</span> – Essential Rules and Features</h2>
        <ol className="rules-list">
          <li>
            Before wagering on bets learn everything you can about the game. Study team performances, player stats,
            and match conditions for better predictions.
          </li>
          <li>
            Make decisions through analytical mindset instead of emotional choices when placing bets. Before betting
            on personal preferences always combine emotional bias with solid analytical thinking.
          </li>
          <li>
            Make betting a form of recreation while refraining from using it as your main financial source. Establish
            boundaries while you partake in the betting activities but avoid excessive betting.
          </li>
          <li>
            Evaluate various betting opportunities so you can determine which method gives you the most success.
            Begin betting with minimal wagers until you develop your approach through experience.
          </li>
        </ol>
        <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </div>
    </section>
  );
};

export default SupportAndRules;
